module.exports = __webpack_public_path__ + "media/logos/msnbc-logo-white-small-8c25ef3d.png";